import React, { FC } from 'react'
import "../css/preview-component.css"
import TextFieldInline from '../../../../component-controller-mod/component-serv/input-fs-cp/text-field-op/ts/textFieldInline'
import { Toggle, Button } from '@core/uilibrary'

type SinglePreviewCmpProp = {
    title?: string;
    valueInput?: string;
}

export const SinglePreviewCmp: FC<SinglePreviewCmpProp> = ({ title, valueInput }) => {
    return (
        <div className='scl--spc-box-container'>
            <div className='border-style'></div>
            <h6>{title}</h6>
            <div className='text-field-style'>
                <TextFieldInline value={valueInput} disabled />
            </div>
        </div>
    )
}

type TitleToggleCmpProp = {
    title?: string;
    toggleEnable?: boolean;
    toggleStatus?: boolean;
};

export const TitleToggleCmp: FC<TitleToggleCmpProp> = ({
    title,
    toggleEnable,
    toggleStatus,
}) => {
    return (
        <div className="scl--ttgle-box-contianer">
            <h6 className='h6-txt'>{title}</h6>
            {toggleEnable && <Toggle checked={Boolean(toggleStatus)} state="disabled" />}
        </div>
    );
};

export const TitleSectionToggleCmp: FC<TitleToggleCmpProp> = ({
    title,
    toggleEnable,
    toggleStatus,
}) => {
    return (
        <div className="scl--ttgle-box-contianer ttbc">
            <h6 className='h6-txt'>{title}</h6>
            {toggleEnable && <Toggle checked={Boolean(toggleStatus)} state="disabled" />}
        </div>
    );
};

type SingleDescriptionCmpProp = {
    description?: string;
    valueTextarea?: string;
}

export const SingleDescriptionCmp: FC<SingleDescriptionCmpProp> = ({ description, valueTextarea }) => {
    return (
        <div className='scl--sdp-box-container'>
            <div className='border-style'></div>
            <p className='p-text'>{description}</p>
            <div className='textarea-field-style'>
                <textarea name="" id="" value={valueTextarea} disabled></textarea>
            </div>
        </div>
    )
}

type SingleImageCmpProp = {
    imgSrc?: string;
    imgAlt?: string;
    imgTitle?: string;
    imgSize?: string;
}

export const SingleImageCmp: FC<SingleImageCmpProp> = ({ imgSrc, imgAlt, imgTitle, imgSize }) => {
    return (
        <div className='scl--sic-box-container'>
            <div className='img-style'>
                <img src={imgSrc} alt={imgAlt} />
            </div>

            <div className='title-img'>
                <h6>{imgTitle}</h6>
                <span>{imgSize}</span>
            </div>
        </div>
    )
}

type SingleImageButtonCmpProp = {
    imgSrc?: string;
    imgAlt?: string;
    imgTitle?: string;
    valueInput?: string;
}

export const SingleImageButtonCmp: FC<SingleImageButtonCmpProp> = ({ imgSrc, imgAlt, imgTitle, valueInput }) => {
    return (
        <div className='scl--sib-box-container'>
            <div className='img-container'>
                <div className='img-style'>
                    <img src={imgSrc} alt={imgAlt} />
                </div>

                <h6>{imgTitle}</h6>
            </div>
            <div className='textfield-style'>
                <TextFieldInline value={valueInput} disabled />
            </div>
        </div>
    )
}
